import React from 'react';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Container from 'react-bootstrap/Container';
import { NavItem } from 'react-bootstrap';
import thIcon from './../../Assets/travelHearts-icon.jpg';
import { logout } from '../../services/authentication.service';
import { useNavigate } from 'react-router-dom';
import { Menu } from 'lucide-react';
import SiteNavbar from './site-navbar';
import Button from '../UI/button';
import SvgIcon from '../SVG/svg';
import Notifications from './notifications';
import ProfileDropdown from './profile-dropdown';
import { NotificationBell } from '../Notifications';
import MobileDrawer from './mobile-drawer';

function IndexNavbar() {
  const [navbarColor, setNavbarColor] = React.useState('navbar-transparent');
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [loggedInUser, setLoggedInUser] = React.useState<any>(null);
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const navigate = useNavigate();
  const handleLogout = () => {
    logout();
    navigate('/');
  };

  React.useEffect(() => {
    const tmpLoggedInUser = localStorage.getItem('user');
    if (tmpLoggedInUser) {
      setLoggedInUser(JSON.parse(tmpLoggedInUser).data.user);
      console.log(tmpLoggedInUser);
      console.log(JSON.parse(tmpLoggedInUser));
    }
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor('');
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor('navbar-transparent');
      }
    };
    window.addEventListener('scroll', updateNavbarColor);
    return function cleanup() {
      window.removeEventListener('scroll', updateNavbarColor);
    };
  }, []);

  return (
    <div className='index-navbar'>
      <header className='index-navbar-header'>
        <div className='d-flex justify-content-between align-items-center'>
          <div className='flex-lg-shrink-0'>
            <a
              href='/'
              className='h3 text-dark fw-bold text-decoration-none'
            >
              Travel<span className='text-primary'>Hearts</span>
            </a>
          </div>

          <div className='d-none d-md-block'>
            <SiteNavbar />
          </div>

          <div className='flex-shrink-0'>
            <div className='navbar-right-slot'>
              <NotificationBell />
              <ProfileDropdown onLogout={handleLogout} />
              <button
                className='hamburger-btn d-md-none'
                onClick={() => setDrawerOpen(true)}
                aria-label='Open navigation menu'
              >
                <Menu size={24} />
              </button>
            </div>
            {/* {loggedInUser === null && (
              <NavItem>
                <Button href='login'>Login</Button>
              </NavItem>
            )} */}
            {/* {loggedInUser && (
              <>
                <div className='mr-3' />
                <NavItem>
                  <div className='btn'>
                    <span>Welcome {loggedInUser?.username}</span>
                  </div>
                </NavItem>
                <div className=' mr-3' />
                <NavItem>
                  <Button
                    className='btn-sm'
                    onClick={handleLogout}
                  >
                    Logout
                  </Button>
                </NavItem>
              </>
            )} */}
          </div>
        </div>
      </header>
      <MobileDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        onLogout={handleLogout}
      />
    </div>
  );
}

export default IndexNavbar;
